<span class="form-input-date">
  <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+ field) | translate" class="input-label"></label>
  <p-datepicker [(ngModel)]="value" [inputId]="id" [iconDisplay]="'input'" [showIcon]="true"
    (ngModelChange)="onInput($event)" (onSelect)="onInput($event)"
    [disabled]="formControl['disabled']" [ngClass]="{ 'disabled': formControl['disabled'] }" [firstDayOfWeek]="firstDayOfWeek"
    [timeOnly]="timeOnly" [stepMinute]="stepMinute" hourFormat="24" [maxDate]="maxDate" [minDate]="minDate" />
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
    [required]="formControl.errors?.['required']"
    [hourAfter]="formControl.errors?.['hourAfter']"
    [dateAfter]="formControl.errors?.['dateAfter']"
    [weekDayIncluded]="formControl.errors?.['weekDayIncluded']"></app-form-input-error>
</span>
  